import React from "react";
import PropTypes from "prop-types";

import "./page-header.scss";
import PageHeaderNavigation from "./PageHeaderNavigation";
import PageHeaderTitle from "./PageHeaderTitle";

function PageHeader({
  title,
  onClickBack,
  titleButtons,
  breadcrumbs,
  toggleSwitch,
  className,
  infoPanelLinks,
}) {
  return (
    <div className={`page-header ${className}`}>
      <PageHeaderNavigation
        breadcrumbs={breadcrumbs}
        infoPanelLinks={infoPanelLinks}
      />
      <PageHeaderTitle
        title={title}
        onClickBack={onClickBack}
        buttons={titleButtons}
        toggleSwitch={toggleSwitch}
      />
    </div>
  );
}

PageHeader.defaultProps = {
  title: "",
  onClickBack: null,
  titleButtons: [],
  breadcrumbs: null,
  toggleSwitch: null,
  className: "",
  infoPanelLinks: null,
};

PageHeader.propTypes = {
  // From parent
  className: PropTypes.string, // The class name to add to the header
  titleButtons: PropTypes.node, // The buttons to display on the right side of the title
  breadcrumbs: PropTypes.arrayOf(
    // The breadcrumbs to display
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string,
    }),
  ),
  infoPanelLinks: PropTypes.objectOf(PropTypes.string),
  title: PropTypes.string, // The title of the page
  onClickBack: PropTypes.func, // The function to call when the back button is clicked
  toggleSwitch: PropTypes.elementType, // The switch to display
};
export default PageHeader;
